import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import { getAuth } from "../firebase";  // Importar la autenticación de Firebase

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    usuario: null
  },
  getters: {
  },
  mutations: {
    // Mutación para configurar el usuario
    setUsuario(state, usuario) {
      state.usuario = usuario;
    },
  },
  actions: {
    // Acción para detectar el usuario actual y configurarlo en el estado
    async detectarUsuario({ commit }) {
      try {
        const auth = getAuth();
        const usuario = auth.currentUser;      
          
        if (usuario) {
          await axios.post('https://choky.agenciabrings.com/php/api.php?action=getUser', {
            uid: usuario.uid
          }).then(res => {                        
            commit('setUsuario', res.data.data[0]);                               
          })
        }
      } catch (error) {
        console.log(error);
      }
    },

    // Acción para cerrar sesión y eliminar al usuario de la lista de usuarios en línea
    signOut({ commit }) {
      const auth = getAuth();
      auth.signOut().then(() => {
        commit('setUsuario', null);
        window.open("/", "_self");
      }).catch((error) => {
        console.log("Error al cerrar sesión:", error);
      });
    },
  },
});
